import { createEffect, createSignal, on, Show, type JSX } from "solid-js";

import type { DeckLibraryPage, PictureSrc } from "./types";

/** A page of the practice's library shown in place of one of Twelve's drawings. Twelve's drawing comes back when the
 *  page will not load (archived, or hidden from this location since the deck was drawn), so the slide is never left
 *  with a hole where its picture was. */
export function PracticePicture(props: {
  page: DeckLibraryPage;
  pictureSrc: PictureSrc;
  alt: string;
  class: string | undefined;
  /** Twelve's drawing. */
  fallback: JSX.Element;
}): JSX.Element {
  const src = () => props.pictureSrc({ kind: "library_page", pageId: props.page.pageId });
  const [failed, setFailed] = createSignal(false);
  createEffect(on(src, () => setFailed(false), { defer: true }));
  return (
    <Show when={!failed()} fallback={props.fallback}>
      <img
        class={props.class}
        src={src()}
        alt={props.alt}
        width={props.page.width ?? undefined}
        height={props.page.height ?? undefined}
        onError={() => setFailed(true)}
      />
    </Show>
  );
}
